
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/plans-and-pricing",
      function () {
        return require("private-next-pages/plans-and-pricing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/plans-and-pricing"])
      });
    }
  